import { render, staticRenderFns } from "./PlanejamentoAcaoTabela.vue?vue&type=template&id=032d4064"
import script from "./PlanejamentoAcaoTabela.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoTabela.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoTabela.vue?vue&type=style&index=0&id=032d4064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports